module.exports = __webpack_public_path__ + "static/media/collections_02.83bf577b.png";